// Live chat - Footer link
document.addEventListener("DOMContentLoaded", function () {
  function isMobile() {
    return window.innerWidth <= 767;
  }

  function handleLiveChatClick(selector) {
    let chatTrigger = document.querySelector(selector);
    chatTrigger?.addEventListener("click", function () {
      const hostElement = document.querySelector("#shopify-chat inbox-online-store-chat");
      if (!hostElement) return;

      const shadowRoot = hostElement.shadowRoot;
      const chatToggle = shadowRoot?.querySelector(".chat-toggle");

      document.querySelector("#shopify-chat").style.visibility = "visible";
      chatToggle?.click();
    });
  }

  function closeChatOnClick() {
    const hostElement = document.querySelector("#shopify-chat inbox-online-store-chat");
    if (!hostElement) return;

    const shadowRoot = hostElement.shadowRoot;
    const closeButton = shadowRoot?.querySelector(".chat-app--close-button");
    const closeButtonMobile = shadowRoot?.querySelector('button[name="closeChat"]');

    [closeButton, closeButtonMobile].forEach((btn) => {
      btn?.addEventListener("click", function () {
        document.querySelector("#shopify-chat").style.visibility = "hidden";
      });
    });
  }

  // Handle clicks for both desktop and mobile chat buttons
  handleLiveChatClick(".c-live-chat");
  handleLiveChatClick(".mobile-live-chat");

  setTimeout(() => {
    handleLiveChatClick(".c-live-chat");
    handleLiveChatClick(".mobile-live-chat");
  }, 2000);

  setInterval(closeChatOnClick, 1000);
});
